import RestService from './RestService';
import axios from 'axios';
import { Auth } from 'aws-amplify';

async function createSnippet(snippet) {
	const res = await RestService.performRestOpNext(`authorizer/snippet/create`, snippet);
	return res;
}

async function getS3UploadUrl(fileName) {
	const res = await RestService.performRestOpNext(`authorizer/s3/upload-url`, { fileName });
	return res;
}

async function createImageSnippet(file, fileName, snippet) {
	const { url, signedUrl } = await getS3UploadUrl(fileName);
	await uploadFileToS3(signedUrl, file);
	snippet.image = url;
	const res = await createSnippet(snippet);
	return { snippetId: res, imageUrl: url };
}

async function uploadFileToS3(url, file) {
	console.log('uploadFileToS3----->', url);
	try {
		await axios.put(url, file, {
			headers: {
				'Content-Type': file.type
			}
		});
	} catch (e) {
		console.error(e);
	}
}

async function myRecentSnippets() {
	const user = await Auth.currentAuthenticatedUser();
	console.log(user);
	const query = {
		size: 10,
		body: {
			query: {
				query_string: {
					query: user.attributes.email,
					default_field: 'username'
				}
			},
			sort: [{ 'snippetId.keyword': { order: 'desc' } }]
		}
	};
	const res = await RestService.performRestOpNext(`authorizer/snippet/search`, query);
	return res;
}

async function getAuthors() {
	const query = {
		body: {
			query: {
				query_string: {
					query: 'AuthorSnippet',
					default_field: 'snippetType'
				}
			},
			sort: [{ 'snippetId.keyword': { order: 'desc' } }]
		}
	};
	const res = await RestService.performRestOpNext(`authorizer/snippet/search`, query);
	return res;
}

async function getSnippet(snippetType, snippetId) {
	const res = await RestService.performRestOpNext(`authorizer/snippet/get`, {
		snippetType,
		snippetId
	});
	console.log(res);
	return res;
}

async function updateSnippet(snippet) {
	const res = await RestService.performRestOpNext(`authorizer/snippet/update`, snippet);
	console.log(res);
	return res;
}

export default {
	getSnippet,
	myRecentSnippets,
	getAuthors,
	createSnippet,
	createImageSnippet,
	updateSnippet
};
